import React, {useLayoutEffect, useRef, useState} from 'react';
import {
    CalendarIframeScaleRoot,
    CalendarIframeScaleClip,
    CalendarIframeScaleInner,
} from './styles';

/** Tamanho nativo do embed Investing (documento interno ~650px de largura útil) */
export const INVESTING_IFRAME_WIDTH = 650;
export const INVESTING_IFRAME_HEIGHT = 467;

/** Fração da largura útil do card */
const WIDTH_RATIO = 1;
/** 1 = preenche a largura; scale pode passar de 1 (upscale) se o card for mais largo que 650px */
const CONTENT_SHRINK = 1;

/**
 * Escala o iframe à largura do card (650×467 nativos × scale). Acima de 650px o widget amplia.
 */
export default function InvestingCalendarEmbed({src, title, id = 'iframe-calendar'}) {
    const rootRef = useRef(null);
    const [scale, setScale] = useState(1);

    useLayoutEffect(() => {
        const el = rootRef.current;
        if (!el) return;

        const update = () => {
            const cw = el.clientWidth;
            if (cw <= 0) return;
            const next = (cw * WIDTH_RATIO / INVESTING_IFRAME_WIDTH) * CONTENT_SHRINK;
            setScale(next);
        };

        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    const visualW = INVESTING_IFRAME_WIDTH * scale;
    const visualH = INVESTING_IFRAME_HEIGHT * scale;

    return (
        <CalendarIframeScaleRoot
            ref={rootRef}
            style={{height: visualH}}
            className="calendar-iframe-scale-root"
        >
            <CalendarIframeScaleClip
                style={{
                    width: visualW,
                    height: visualH,
                }}
            >
                <CalendarIframeScaleInner
                    style={{
                        width: INVESTING_IFRAME_WIDTH,
                        height: INVESTING_IFRAME_HEIGHT,
                        transform: `scale(${scale})`,
                    }}
                >
                    <iframe
                        id={id}
                        title={title}
                        src={src}
                        width={INVESTING_IFRAME_WIDTH}
                        height={INVESTING_IFRAME_HEIGHT}
                        frameBorder="0"
                        allowTransparency="true"
                        marginWidth="0"
                        marginHeight="0"
                    />
                </CalendarIframeScaleInner>
            </CalendarIframeScaleClip>
        </CalendarIframeScaleRoot>
    );
}
